const ctx = require.context(
    '../assets/logos',
    false,
    /\.(svg|gif|png|jpe?g|webp)$/i
);

const LOGO_MAP = {};
ctx.keys().forEach((key) => {
    // './logo-1000.svg' -> 'logo-1000.svg'
    const filename = key.replace('./', '');
    // 'logo-1000' 또는 '1000'
    const base = filename.replace(/\.(svg|gif|png|jpe?g|webp)$/i, '');
    // 접두어 logo-, logo_ 제거 → '1000'
    const code = base.replace(/^logo[-_]?/i, '');
    const mod = ctx(key);
    const url = mod?.default || mod;
    LOGO_MAP[code] = url;         // 코드로 조회 가능 (e.g., LOGO_MAP['1000'])
    LOGO_MAP[filename] = url;     // 파일명으로도 조회 가능 (옵션)
});

export function getLogoUrl({ code, file, fallback = 'default.svg' } = {}) {
    // 명시 파일명이 있으면 우선
    if (file && LOGO_MAP[file]) return LOGO_MAP[file];
    // 회사 코드로 매칭
    if (code && LOGO_MAP[code]) return LOGO_MAP[code];
    // 폴백: default.svg가 있으면 사용
    return LOGO_MAP[fallback] || null;
}